import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  sceneInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.backgrounds.cardBackground,
    padding: '2% 3%',
    marginBottom: 10,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 50,
  },
  sceneInfoTextMobile: {
    maxWidth: '70%',
  },
  iconButton: {
    padding: 5,
  },
  andText: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 5,
    fontSize: '17px',
  },
  deleteWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  rightElementWrapper: {
    display: 'flex',
  },
  errorOutline: {
    marginRight: 3,
  },
}))

export default useStyles
